import { useEffect } from 'react';
import CookiesManager from '@/shared/cookies-manager';

export const useAffinityId = (): void => {
  useEffect(() => {
    if (CookiesManager.getAffinityIdCookie() == null) {
      CookiesManager.setAffinityIdCookie();
    }
  }, []);
};
